import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../store/appStore';
import { Input } from '../components/ui/input';
import { TeacherCard } from '../components/Cards';

export default function TeachersPage() {
  const { t, i18n } = useTranslation();
  const { teachers, fetchTeachers } = useAppStore();
  const [loading, setLoading] = useState(true);
  const [city, setCity] = useState('');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      await fetchTeachers(city ? { city } : {});
      setLoading(false);
    };
    load();
  }, [fetchTeachers, city]);

  return (
    <div className="max-w-6xl mx-auto px-4 py-8 animate-fade-in" data-testid="teachers-page">
      <h1 className="font-serif text-4xl font-bold text-primary mb-8">{t('teacher.title')}</h1>
      
      <div className="mb-8">
        <Input placeholder={t('common.location')} value={city} onChange={(e) => setCity(e.target.value)} className="w-64" data-testid="filter-city" />
      </div>

      {loading ? (
        <div className="text-center py-12"><p className="text-secondary">{t('common.loading')}</p></div>
      ) : teachers.length === 0 ? (
        <div className="text-center py-12"><p className="text-secondary">{t('common.noResults')}</p></div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {teachers.map((teacher) => (
            <TeacherCard key={teacher.id} teacher={teacher} language={i18n.language} />
          ))}
        </div>
      )}
    </div>
  );
}
